define.alias("ember-functions-as-helper-polyfill/initializers/install-function-helper-manager", "settings/initializers/install-function-helper-manager");